export const CLEAR_SELECT_FILES = "CLEAR_SELECT_FILES";
export const UPDATE_SELECT_FILES = "UPDATE_SELECT_FILES";
